<ng-container>
    <div class="overlay-warp">
        <div class="itemx" *ngFor="let item of statusList">
            <div [ngSwitch]="item.status">
                <div class="item-list">
                    <div class="choose" [ngClass]="{'selected': item.choosed}" (click)="selectStatus(item)">
                        <div class="inner-selected">
                            <img src="/assets/images/auto-fill/vi.svg">
                        </div>
                    </div>
                    <div *ngSwitchCase="enumExportStatus.Exported" class="st approvaled">
                        <p translate>column.reports.mlmExportStatusValue.exported</p>
                    </div>
                    <div *ngSwitchCase="enumExportStatus.Failed" class="st rejected">
                        <p translate>column.reports.mlmExportStatusValue.failed</p>
                    </div>
                    <div *ngSwitchCase="enumExportStatus.NotExported" class="st pending-approval">
                        <p translate>column.reports.mlmExportStatusValue.notExported</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
